import { getErrorMessage } from "@/utils/requestUtils";
import { useEffect } from "react";
import { toast } from "@/lib/toast";

function UseErrorHandler({
  title,
  isError,
  error,
}: {
  title: string;
  isError: boolean;
  error: any;
}) {
  useEffect(() => {
    if (isError && error) {
      toast.error(
        <div className="flex flex-col">
          <span className="font-semibold">{title}</span>
          <span className="text-sm">{getErrorMessage(error)}</span>
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        },
      );
    }
  }, [error, isError, title]);
}

export default UseErrorHandler;
